import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { createFormula, evaluateFormula, getFormula, getFormulas, updateFormula } from '../../repositories/HttpRepository';

export default function useFormula() {
  const [formulas, setFormulas] = useState();
  const [formula, setFormula] = useState();

  const [value, setValue] = useState();
  const [evalError, setEvalError] = useState();

  const { id } = useParams();

  const [type, setType] = useState();

  useEffect(() => {
    if (id) {
      getFormula(id).then((resp) => {
        if (resp.ok) {
          let f = resp.data;
          f.config = JSON.stringify(f.config);
          f.data = JSON.stringify(f.data);

          setFormula(f);
        }
      });
    } else {
      getFormulas({ type }).then((response) => {
        if (response.ok) {
          setFormulas(response.data.items);
        }
      });
    }
  }, [type]);

  const add = (formula) => {
    return createFormula(formula).then((resp) => {
      if (resp.ok) {
        let f = resp.data;
        f.config = JSON.stringify(f.config);
        f.data = JSON.stringify(f.data);
        setFormula(f);
      }

      return resp;
    });
  };

  const update = (id, formula) => {
    return updateFormula(id, formula).then((resp) => {
      if (resp.ok) {
        let f = resp.data;
        f.config = JSON.stringify(f.config);
        f.data = JSON.stringify(f.data);
        setFormula(f);
      }

      return resp;
    });
  };

  const evaluate = (formula) => {
    return evaluateFormula(formula).then((resp) => {
      if (resp.ok) {
        setValue(resp.data);
      } else if (resp.status === 400) {
        setValue(null);
        setEvalError('Formula error, please check again! ');
      } else {
        setValue(null);
        setEvalError('Formula error, please check again! ');
      }

      return resp;
    });
  };

  return {
    formulas,
    type,
    setType,
    formula,
    add,
    update,
    evaluate,
    value,
    evalError,
  };
}
